<template>
  <div class="notice" style="height: 0px;">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          <template v-if="!data.notice.id">
            新增
          </template>
          <template v-else>
            编辑
          </template>
          通知公告
        </el-text>
        <el-button-group>
          <el-button @click="router.go(-1)">返回</el-button>
          <el-button type="primary" @click="save()" :loading="loading.save">保存</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="ID" v-if="data.notice.id">
        <el-input v-model="data.notice.id" disabled />
      </el-form-item>
      <el-form-item label="Type">
        <el-select filterable clearable v-model="data.notice.type" style="width: 100%;">
          <el-option label="中央选调生" value="ZYXDS" />
          <el-option label="定向选调生" value="DXXDS" />
          <el-option label="普通选调生" value="PTXDS" />
          <el-option label="客服" value="KF" />
          <el-option label="系统设置" value="SYSTEM" />
        </el-select>
      </el-form-item>
      <el-form-item label="Key">
        <el-input v-model="data.notice.kkey" />
      </el-form-item>
      <el-form-item label="是否展示">
        <el-select filterable clearable v-model="data.notice.hasShow" style="width: 100%;">
          <el-option label="是" :value="true" />
          <el-option label="否" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item label="标题">
        <el-input v-model="data.notice.title" />
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number style="width: 100%;" :controls="false" :precision="0" v-model="data.notice.sort" />
      </el-form-item>
      <el-form-item label="内容">
        <el-input v-model="data.notice.content" type="textarea" />
      </el-form-item>
      <el-form-item label="内容">
        <Editor v-model="data.notice.content" style="min-height: 400px;height: calc(100vh - 450px)" />
      </el-form-item>
      <el-form-item label="文件">
        <el-upload style="width: 100%;" v-model:file-list="data.file.file" :limit="3" :action="api.baseURL() + '/backend/file/upload'" :headers="api.tokenHeader()" multiple drag :on-error="() => ElMessage.error('上传失败')"
          :on-preview="(f) => util.previewElfile(f)" accept=".xlsx">
          <el-text>点击或拖转到此处上传文件（最多3个）</el-text>
        </el-upload>
      </el-form-item>
    </el-form>
    <div style="height: 10px;"></div>
  </div>
</template>

<script setup>
import { reactive, } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import Editor from '../../components/Editor.vue'

const router = useRouter()
const loading = reactive({
  save: false,
})
const pageParam = cache.getObject(cache.keys.pageParam + "notice")
const data = reactive({
  notice: pageParam ? JSON.parse(JSON.stringify(pageParam)) : { sort: 0 },
  file: { file: [] },
})
if (data.notice.file) {
  data.file.file = util.json2Elfile(data.notice.file)
}

const save = () => {
  loading.save = true
  const notice = {
    type: data.notice.type,
    kkey: data.notice.kkey || '',
    hasShow: data.notice.hasShow == true,
    title: data.notice.title,
    content: data.notice.content || '',
    sort: data.notice.sort || 0,
    file: util.elfile2Json(data.file.file)
  }
  if (!data.notice.id) {
    api.post('/backend/notice/addNotice', notice).then(() => {
      ElMessage.success('保存成功')
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  } else {
    notice.id = data.notice.id
    api.post('/backend/notice/setNotice', notice).then(() => {
      ElMessage.success('保存成功')
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  }
}
</script>

<style lang="less">
.notice {
  margin: auto;
  max-width: 900px;

  .avatar-uploaded {
    width: 178px;
    height: 178px;
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    margin-right: 20px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
  }

  .avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
  }

  .el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
  }
}
</style>